import { Gondor } from "../Gondor";

const ACTIONS = {
  MAX_PRICE: "/maxPrice/",
  MAX_PRICE_ITEM: "/maxPrice/{id}/",
  ADD_SYSTEMS: "/maxPrice/add/system",
  REMOVE_SYSTEMS: "/maxPrice/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.MAX_PRICE, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.MAX_PRICE_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.MAX_PRICE, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(ACTIONS.MAX_PRICE_ITEM.replace("{id}", id), body);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.MAX_PRICE_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
